export default "__VITE_ASSET__Chti6pnq__"